export const withForm = WrappedComponent => props => {
	return <WrappedComponent {...props} />;
};
